import { themeAwardWidgetDecorator } from '../utils'
import { BowtieReports } from './BowtieReports'

export const BowtieReportsWrapper = themeAwardWidgetDecorator(BowtieReports)
